/* eslint-disable no-case-declarations */
import produce from 'immer';
import {
  GET_ALL_COUNTRIES_SUCCESS,
  GET_ALL_CURRENCIES_SUCCESS,
  GET_ALL_ENUMERATIONS_SUCCESS,
  GET_ALL_PROVINCES_SUCCESS,
  GET_ALL_SALE_TYPES_SUCCESS,
  GET_ALL_WEIGHT_TYPES_SUCCESS
} from './enumeationTypes';

const initialState = {
  isLoaded: false,
  allEnums: null
};

export default produce((draft = initialState, action) => {
  switch (action.type) {
    case GET_ALL_ENUMERATIONS_SUCCESS:
      if (action.response === undefined) {
        break;
      }
      draft.allEnums = action.response;
      draft.isLoaded = true;
      break;

    case GET_ALL_WEIGHT_TYPES_SUCCESS:
      if (action.response === undefined) {
        break;
      }
      draft.allEnums.weightTypes = action.response;
      break;

    case GET_ALL_SALE_TYPES_SUCCESS:
      if (action.response === undefined) {
        break;
      }
      draft.allEnums.saleTypes = action.response;
      break;

    case GET_ALL_PROVINCES_SUCCESS:
      if (action.response === undefined) {
        break;
      }
      draft.allEnums.provinces = action.response;
      break;

    case GET_ALL_COUNTRIES_SUCCESS:
      if (action.response === undefined) {
        break;
      }
      draft.allEnums.countries = action.response;
      break;

    case GET_ALL_CURRENCIES_SUCCESS:
      if (action.response === undefined) {
        break;
      }
      draft.allEnums.currencies = action.response;
      break;

    default:
      break;
  }

  return draft;
}, initialState);
